export const getInitialEdges = () => {
  const edges = [];
  
  const bidiEdge = { type: 'bidi', style: { stroke: '#0b4e96', strokeWidth: 2 } };

  // Connect Users to Apps (downward)
  edges.push(
    { id: 'e-doc-app', source: 'user-doctor', target: 'app-doctor', sourceHandle: 'bottom', targetHandle: 'top', ...bidiEdge },
    { id: 'e-adm-app', source: 'user-admin', target: 'app-doctor', sourceHandle: 'bottom', targetHandle: 'top', ...bidiEdge },
    { id: 'e-pat-app', source: 'user-patient', target: 'app-patient', sourceHandle: 'bottom', targetHandle: 'top', ...bidiEdge }
  );

  // Connect Apps to Middle Layer (downward)
  edges.push(
    { id: 'e-app-exam', source: 'app-doctor', target: 'group-exam', sourceHandle: 's-exam', targetHandle: 'top', ...bidiEdge },
    { id: 'e-app-mgmt', source: 'app-doctor', target: 'group-mgmt', sourceHandle: 's-mgmt', targetHandle: 'top', ...bidiEdge },
    { id: 'e-app-pat', source: 'app-patient', target: 'group-pat', sourceHandle: 'bottom', targetHandle: 'top', ...bidiEdge }
  );

  // Middle Layer to Data Exchange (downward) - single middle line connecting the large wrappers
  edges.push(
    { id: 'e-mid-exc', source: 'wrap-mid', target: 'wrap-exc', sourceHandle: 'bottom', targetHandle: 'top', ...bidiEdge }
  );

  // Data Exchange to Bus (downward)
  edges.push(
    { id: 'e-byt-bus', source: 'group-byt', target: 'group-bus', sourceHandle: 'bottom', targetHandle: 'top', ...bidiEdge },
    { id: 'e-oth-bus', source: 'group-other', target: 'group-bus', sourceHandle: 'bottom', targetHandle: 'top', ...bidiEdge },
    { id: 'e-int-bus', source: 'group-int', target: 'group-bus', sourceHandle: 'bottom', targetHandle: 'top', ...bidiEdge }
  );

  // DB Layer internal horizontal connections and Bus to DB connections
  // User noted an extra line from CSDL Bệnh viện to CSDL Bên ngoài. 
  // In the target diagram, there is only a single one-way arrow from Internal DB to Data Warehouse.
  const dbEdge = { type: 'default', animated: true, style: { stroke: '#0b4e96', strokeWidth: 2 } };
  edges.push(
    { id: 'e-db-int-wh', source: 'group-db-int', target: 'group-db-wh', sourceHandle: 'right', targetHandle: 'left', ...dbEdge },
    
    // Lines from Bus down to Data Warehouse (only 1 line in the middle from wrapper)
    // M 1150, 1240 -> L 1150, 1300 (Center of group-db-wh, starting from bottom of wrap-exc)
    { 
      id: 'e-bus-db-wh', source: 'wrap-exc', target: 'group-db-wh', 
      sourceHandle: 'bottom', targetHandle: 'top', ...bidiEdge,
      data: { customPath: "M 1150,1240 L 1150,1300" }
    }
  );

  // Left Sidebar to Core Area
  const sideGreenBidi = { type: 'bidi', animated: true, style: { stroke: '#00A651', strokeWidth: 2, strokeDasharray: '5 5' } };
  
  edges.push(
    // Connect the top 5 items to group-other with a custom orthogonal path
    // M 250,538: Start between Payment and BHXH
    // L 280,538: Right to clear sidebar
    // L 280,710: Down to the horizontal gap between middle and exchange layers
    // L 845,710: Right through the gap, stopping between group-byt (ends 820) and group-other (starts 870)
    // L 845,880: Down through the vertical gap to the center of group-other
    // L 870,880: Right into group-other
    { 
      id: 'e-ext-top', source: 'ext-top-group', target: 'group-other', 
      sourceHandle: 'right', targetHandle: 'h-oth', ...sideGreenBidi,
      data: { customPath: "M 250,538 L 280,538 L 280,710 L 845,710 L 845,880 L 870,880" }
    },
    
    // Connect the bottom 2 items to group-byt (Bộ Y tế) - specifically LGSP
    // M 250,897: Start between VNEID and Bo Y Te
    // L 280,897: Right to clear sidebar
    // L 280,975: Down to align with h-lgsp
    // L 400,975: Right into h-lgsp (group-byt starts at absolute x=400)
    { 
      id: 'e-ext-bot', source: 'ext-bot-group', target: 'group-byt', 
      sourceHandle: 'right', targetHandle: 'h-lgsp', ...sideGreenBidi,
      data: { customPath: "M 250,897 L 280,897 L 280,975 L 400,975" }
    }
  );

  // Security (Right Sidebar) connects to the rightmost element of every layer horizontally!
  const bidiRightEdge = { type: 'bidi', style: { stroke: '#0b4e96', strokeWidth: 4 } }; 
  
  edges.push(
    { id: 'e-sec-user', source: 'wrap-users', target: 'group-sec', sourceHandle: 'right', targetHandle: 'h-users', ...bidiRightEdge },
    { id: 'e-sec-app', source: 'wrap-apps', target: 'group-sec', sourceHandle: 'right', targetHandle: 'h-apps', ...bidiRightEdge },
    { id: 'e-sec-mid', source: 'wrap-mid', target: 'group-sec', sourceHandle: 'right', targetHandle: 'h-mid', ...bidiRightEdge },
    { id: 'e-sec-exc', source: 'wrap-exc', target: 'group-sec', sourceHandle: 'right', targetHandle: 'h-exc', ...bidiRightEdge },
    { id: 'e-sec-db', source: 'group-db-ext', target: 'group-sec', sourceHandle: 'right', targetHandle: 'h-db', ...bidiRightEdge },
    { id: 'e-sec-infra', source: 'group-infra', target: 'group-sec', sourceHandle: 'right', targetHandle: 'h-infra', type: 'bidi', style: { stroke: '#94a3b8', strokeWidth: 4 } } 
  );

  // Integration Bus zig-zag connection to Apps and DB
  const zigZagEdge = { type: 'bidi', style: { stroke: '#10b981', strokeWidth: 2, strokeDasharray: '5,5' } };
  edges.push(
    { 
      id: 'e-bus-app-zz', source: 'group-bus', target: 'group-pat', 
      sourceHandle: 'right', targetHandle: 'r-target', 
      ...zigZagEdge,
      data: { customPath: `M 1760 1150 L 1820 1150 L 1820 600 L 1760 600` }
    },
    { 
      id: 'e-bus-db-zz', source: 'group-bus', target: 'group-db-ext', 
      sourceHandle: 'right', targetHandle: 'r-target', 
      ...zigZagEdge,
      data: { customPath: `M 1760 1150 L 1820 1150 L 1820 1350 L 1660 1350` }
    }
  );

  // Connection from dotted databases group to LGSP in Data Exchange layer
  edges.push(
    { id: 'e-byt-dbs-lgsp', source: 'group-byt-dbs', target: 'byt-lgsp', sourceHandle: 's-bot', targetHandle: 't-top', type: 'bidi', style: { stroke: '#38bdf8', strokeWidth: 4 } }
  );

  return edges;
};
